var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 19.3333L19.4244 19.2889C19.7094 19.1465 20.0292 19.0888 20.3459 19.1226C20.6627 19.1563 20.9631 19.2801 21.2117 19.4794C21.4602 19.6786 21.6465 19.9448 21.7484 20.2466C21.8503 20.5484 21.8636 20.8731 21.7867 21.1822L20.2133 27.4844C20.1359 27.7937 20.1488 28.1187 20.2504 28.4209C20.3521 28.723 20.5383 28.9897 20.787 29.1893C21.0356 29.3888 21.3363 29.5128 21.6533 29.5466C21.9703 29.5804 22.2904 29.5226 22.5756 29.38L22.6667 29.3333M41 21C41 23.6264 40.4827 26.2272 39.4776 28.6537C38.4725 31.0802 36.9993 33.285 35.1421 35.1421C33.285 36.9993 31.0802 38.4725 28.6537 39.4776C26.2272 40.4827 23.6264 41 21 41C18.3736 41 15.7728 40.4827 13.3463 39.4776C10.9198 38.4725 8.71504 36.9993 6.85786 35.1421C5.00069 33.285 3.5275 31.0802 2.52241 28.6537C1.51732 26.2272 1 23.6264 1 21C1 15.6957 3.10714 10.6086 6.85786 6.85786C10.6086 3.10714 15.6957 1 21 1C26.3043 1 31.3914 3.10714 35.1421 6.85786C38.8929 10.6086 41 15.6957 41 21ZM21 12.6667H21.0178V12.6844H21V12.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/alerta.9cf2873b3a2e465926659bebf2ac346a.svg";
export { ForwardRef as ReactComponent };